var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { description, property_features, schools_list, display_key_facts,
         property_type, community_builder, community_name, community_description, communityFeatures,
         leadSubmitted, isLeadFormSuppressed, canonical, realTip, propertyStatus,
         pageType, ctaButtonName, ctaText, community_icon, communityUrl,
         photos, planName, beds, baths, sqft, videoLink, ncSearchUrl, prevSearchLoc, matterportUrl, matterportThumb, isSellerPromoted, hasSuppressLeadForm } = options; 
__p+='\n\n';
 if(ctaText == 'V1' && ctaButtonName == "Contact Agent") { 
__p+='\n  ';
 ctaButtonName = "Contact an Agent" 
__p+='\n';
 } 
__p+='\n\n';
 let propertyName = 'property' 
__p+='\n';
 if (property_type === 'new_plan') { 
__p+='\n  ';
 propertyName = 'plan' 
__p+='\n';
 } 
__p+='\n\n<div class="qv-property-details" id="qv-property-details">\n  <div class="panel">\n    <div class="accordion-heading collapsed" role="tab" data-toggle="collapse" href="#collapse-property-details" aria-expanded="false" aria-controls="collapse-property-details" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':property-details:expand">\n      <h2 class="title-section accordion-title">\n        <i class="ra ra-property-features icon-space-right"></i>'+
((__t=( propertyName.capitalize() ))==null?'':__t)+
' Details\n      </h2>\n      <p class="sec-summary summary-details ellipsis">\n        '+
((__t=(  description ?  description.truncate(100) : 'Interior and exterior features' ))==null?'':__t)+
'\n      </p>\n      <div id="div-gpt-ad-PRPTYLOGO1" class="property-details-sponsorship" ></div>\n    </div>\n    <div id="collapse-property-details" class="panel-collapse collapse" role="tabpanel" aria-labelledby="collapse-property-details">\n      <div id="div-gpt-ad-TXTPRPTY1" class="details-sponsorship-qoute"></div>\n      ';
 if ($.Device.isMobile(navigator.userAgent)) { 
__p+='\n        ';
 if (property_type == "for_sale") { 
__p+='\n          '+
((__t=( JST['quick_view/templates/realtip_section']({
              realTip
          }) ))==null?'':__t)+
'\n        ';
 } 
__p+='\n      ';
 } 
__p+='\n\n      <div class="panel-body">\n        <div class="js-details-load-more">\n          ';
 if(description) { 
__p+='\n            <p class="description">'+
((__t=( description ))==null?'':__t)+
'</p>\n          ';
 } 
__p+='\n          ';
 if(schools_list) { 
__p+='\n            <div class="margin-top clearfix schools-list-wrapper">\n              <h4 class="font-semibold">Schools</h4>\n              <ul class="list-default">\n                ';
 schools_list.schools.forEach((school) => { 
__p+='\n                  <li>'+
((__t=( school ))==null?'':__t)+
'</li>\n                ';
 })
__p+='\n              </ul>\n            </div>\n          ';
 } 
__p+='\n        </div>\n        ';
 if(property_type == "new_plan") { 
__p+='\n          ';
 if(photos.length > 0) { 
__p+='\n            <div class="plan-photo-details text-center font-size-large">\n            <img src="'+
((__t=( photos[0].url ))==null?'':__t)+
'" class="plan-detail-image" alt="plan details image">\n              <div class="plan-feature-details">\n                ';
 if(planName) { 
__p+='\n                  <p class="font-bold">'+
((__t=( planName ))==null?'':__t)+
''+
((__t=( planName && planName.toLowerCase().includes("plan") ? "" : " Plan" ))==null?'':__t)+
'</p>\n                  <span>\n                    ';
 if(beds){ 
__p+='\n                      '+
((__t=( beds ))==null?'':__t)+
' Bedroom,\n                    ';
 } 
__p+='\n                    ';
 if(baths){ 
__p+='\n                      '+
((__t=( baths ))==null?'':__t)+
' Bathroom\n                    ';
 } 
__p+='\n                    <br />\n                    ';
 if(sqft){ 
__p+='\n                      '+
((__t=( sqft ))==null?'':__t)+
' sq ft\n                    ';
 } 
__p+='\n                  </span>\n                ';
 } 
__p+='\n              </div>\n            </div>\n          ';
 } 
__p+='\n          ';
 if (!leadSubmitted && !isLeadFormSuppressed && hasSuppressLeadForm) { 
__p+='\n            <div class="margin-top-lg text-center">\n              <span class="font-bold ">Find out more about this '+
((__t=( propertyName ))==null?'':__t)+
'.</span>\n              <a href="javascript:void(0)" data-title="Find out more about this '+
((__t=( propertyName ))==null?'':__t)+
'" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':property-details:contact_agent" class="js-qv-contact-agent btn btn-primary margin-left-lg round-cta" data-placeholder="I would like more details about this '+
((__t=( propertyName ))==null?'':__t)+
'." data-formid="secondary">\n                <div class="icon-email-container"><span class="email-icon"></span><span class="ab-email-text-form">\n                  '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n                  </span></div>\n              </a>\n            </div>\n          ';
 } 
__p+='\n           <div id="qv-other-plans" class="qv-other-floor-plans"></div>\n         ';
 } 
__p+='\n         ';
 if(matterportUrl && matterportThumb && isSellerPromoted && MOVE_DATA.isDesktop) { 
__p+='\n           <div class="matterport-view">\n              <a data-toggle="modal" data-target="#fs-matterport-modal" data-omtag="ldp:photogallery:3d-view">\n                <img class="matterport-frame" src="'+
((__t=( matterportThumb ))==null?'':__t)+
'">\n                <div class="matterport-play-icon">\n                  <i class="play-button"></i>\n                  <p>Explore 3D View </p>\n                </div>\n              </a>\n            </div>\n           ';
 } 
__p+='\n        ';
 if (property_features && property_type === "for_sale") { 
__p+='\n          '+
((__t=( JST['quick_view/templates/qv-subsec-property-features']({ property_type, property_features, canonical }) ))==null?'':__t)+
'\n        ';
 } 
__p+='\n      \n        <div id="aj-qv-building-units" class="qv-sec-building-units ldp-unit-module"> </div>\n          ';
 if (property_type !== "new_plan" && !leadSubmitted && !isLeadFormSuppressed && hasSuppressLeadForm) { 
__p+='\n            <div class="margin-top-lg text-center">\n              <span class="font-bold ">Find out more about this '+
((__t=( propertyName ))==null?'':__t)+
'.</span>\n              <a href="javascript:void(0)" data-title="Find out more about this '+
((__t=( propertyName ))==null?'':__t)+
'" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':property-details:contact_agent" class="js-qv-contact-agent btn btn-primary margin-left-lg round-cta" data-placeholder="I would like more details about this '+
((__t=( propertyName ))==null?'':__t)+
'." data-formid="secondary">\n                <div class="icon-email-container"><span class="email-icon"></span><span class="ab-email-text-form">\n                  '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n                  </span></div>\n              </a>\n            </div>\n          ';
 } 
__p+='\n        ';
 if (property_type === "new_plan") { 
__p+='\n          <div class="margin-top-lg ldp-section-ctas text-center "> \n            <div class=\'visible-xxs-block margin-top\'></div>\n            <span class="font-bold">Search new construction in '+
((__t=( prevSearchLoc ))==null?'':__t)+
'</span>\n            <a href='+
((__t=( ncSearchUrl ))==null?'':__t)+
' class="btn btn-default margin-left-lg round-cta" data-omtag="new_plan:ldp-quickview:plan_details:view_new_homes">\n              <span>View new homes</span>\n            </a>\n          </div>\n        ';
 } 
__p+='  \n        <div class="subsection">\n          <div class="header-subsection header-subsection-home-service no-homsvc1 no-homsvc2 no-homsvc3">\n            <h2 class="">Local Home Services</h2>\n            <div>Advertisement</div>\n          </div>\n          <div id="div-gpt-ad-HOMSVC1" class="home-services-ad"></div>\n          <div id="div-gpt-ad-HOMSVC2" class="home-services-ad"></div>\n          <div id="div-gpt-ad-HOMSVC3" class="home-services-ad"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n';
 if (property_type === "new_plan") { 
__p+='\n  <div class="qv-property-details" id="qv-community-details">\n    <div class="panel">\n      <div class="accordion-heading collapsed" role="tab" data-toggle="collapse" href="#collapse-community-details" aria-expanded="false" aria-controls="collapse-community-details" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':property-details:expand">\n        <h2 class="title-section accordion-title">\n          <img class="community-icon padding-right-icon" src="'+
((__t=( community_icon ))==null?'':__t)+
'" alt="Community icon">Community Details\n        </h2>\n      </div>\n      <div id="collapse-community-details" class="panel-collapse collapse" role="tabpanel" aria-labelledby="collapse-community-details">\n\n        <div class="panel-body">\n          ';
 if (community_name) { 
__p+='\n            ';
 if (MOVE_DATA.community_builder_link && MOVE_DATA.community_builder_link.site) { 
__p+='\n              <div class="builder-href-wrap">\n                <a href="'+
((__t=( MOVE_DATA.community_builder_link.site ))==null?'':__t)+
'"\n                   target="_blank"\n                   rel="nofollow noopener noreferrer"\n                   data-omtag="for_sale:ldp:community_details:broker_site"\n                   class="builder-href">\n                  Visit builder website\n                  <img\n                    alt="'+
((__t=( `This listing is presented by ${MOVE_DATA.community_builder_link.brand_name}` ))==null?'':__t)+
'"\n                    src="'+
((__t=( MOVE_DATA.community_builder_link.photos && MOVE_DATA.community_builder_link.photos[0] && MOVE_DATA.community_builder_link.photos[0].url ))==null?'':__t)+
'"\n                    style="margin-left:10px; height:50px; width:auto"/>\n                </a>\n              </div>\n            ';
 } 
__p+='\n            <p class="font-bold">\n              '+
((__t=( community_name ))==null?'':__t)+
'\n              ';
 if (community_builder) { 
__p+=' by '+
((__t=( community_builder ))==null?'':__t)+
' ';
 } 
__p+='\n            </p>\n            <div class="subsection">\n              ';
 if(community_description) { 
__p+='\n                <p>'+
((__t=( community_description ))==null?'':__t)+
'</p>\n              ';
 } 
__p+='\n            </div>\n          ';
 } 
__p+='\n\n          <div class="padding-top">\n            ';
 if (videoLink && videoLink.href) { 
__p+='\n              <a target="_blank"\n                 class="about_community_video"\n                 href="'+
((__t=( videoLink.href ))==null?'':__t)+
'"\n                 rel="external noopener noreferrer"\n                 data-omtag="for_sale:ldp_quickview:community_details:video_tour"\n                 aria-label="'+
((__t=( `${community_name} video link (opens in a tab)` ))==null?'':__t)+
'">\n                <i class="play-button"></i>\n                <span> Video tour</span>\n              </a>\n            ';
} 
__p+='\n            ';
 if (communityUrl) { 
__p+='\n              <div class="display-inline-block">\n                <a href="'+
((__t=( communityUrl ))==null?'':__t)+
'">View the Community</a>\n              </div>\n            ';
 } 
__p+='\n          </div>\n\n          ';
 if(communityFeatures) { 
__p+='\n            '+
((__t=( JST['quick_view/templates/qv-subsec-community-features']({ communityFeatures }) ))==null?'':__t)+
'\n          ';
 } 
__p+='\n          ';
 if (!leadSubmitted && !isLeadFormSuppressed && hasSuppressLeadForm) { 
__p+='\n            <div class="margin-top-lg text-center">\n              <span class="font-bold ">Find out more about this community.</span>\n              <a href="javascript:void(0)" data-title="Find out more about this community" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':community-details:contact_agent" class="js-qv-contact-agent btn btn-primary margin-left-lg round-cta" data-placeholder="I would like more details about this community." data-formid="secondary">\n                '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n              </a>\n            </div>\n          ';
 } 
__p+='\n        </div>\n      </div>\n    </div>\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-property-details.jst.ejs